import appConfigStoreModule from "@core/@app-config/appConfigStoreModule";
import Vue from "vue";
import Vuex from "vuex";

import adb from "./adb";
import admin from "./admin";
import aiFactory from "./ai-factory";
import aiFactoryTmp from "./ai-factory-tmp";
import alerts from "./alerts";
import app from "./app";
import audience from "./audience";
import axios from "./axios";
import c2c from "./c2c";
import common from "./common";
import finance from "./finance";
import general from "./general";
import gd from "./gd";
import marmiton from "./marmiton";
import premium from "./premium";
import regie from "./regie";
import rmra from "./rmra";
import seo from "./seo";
import redac from "./redac";
import webPerf from "./web-perf";
import linkMessApps from "./link-mess-apps";
import gtrends from "./gtrends";
import acquisition from "./acquisition";
import dataAvailability from "./data-availability";
import newsRadar from "./news-radar";
import marketing from "./marketing";
import dashboardV2 from "./dashboard-v2";
import youtubePerf from "./youtube-perf";
import editorial from "./editorial";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    adb,
    admin,
    aiFactory,
    aiFactoryTmp,
    alerts,
    app,
    audience,
    acquisition,
    axios,
    c2c,
    common,
    dashboardV2,
    youtubePerf,
    dataAvailability,
    finance,
    general,
    gd,
    gtrends,
    linkMessApps,
    marmiton,
    newsRadar,
    marketing,
    premium,
    redac,
    regie,
    rmra,
    seo,
    webPerf,
    editorial,
  },
});
